'use client';
import { useState, useLayoutEffect } from "react";
const useInheritDocDirection = (args) => {
  const defaultDir = (args == null ? void 0 : args.locale) === "ar" ? "rtl" : "ltr";
  const [direction, setDirection] = useState(defaultDir);
  useLayoutEffect(() => {
    const updateDirection = () => {
      const dir = document.documentElement.dir || document.body.dir || defaultDir;
      setDirection(dir);
    };
    updateDirection();
    const observer = new MutationObserver(updateDirection);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["dir"]
    });
    return () => observer.disconnect();
  }, [defaultDir]);
  return { direction };
};
export {
  useInheritDocDirection
};
